import { emptyTank, actions } from '../constants/tanks_constants.js';

const initialState = {
    areas: [],
    operations: [],
    currentTank: Object.assign({}, emptyTank),
    tanksStateOperations: [],
    operationsFilter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            tankName: "",
            dateFrom: null,
            dateTo: null
        },
    },
    tanksStateOperationsFilter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            tankName: "",
            dateFrom: null,
            dateTo: null
        },
    },
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 }
    },
    loading: false,
    errors: {},
    forceReload: false
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
    case actions.START_REQUEST:
    {
        return {
            ...state,
            loading: true
        };
    }
    case actions.END_REQUEST:
    {
        return {
            ...state,
            loading: false
        };
    }
    case actions.GET_TANKS:
    {
        return {
            ...state,
            tanks: action.tanks.items,
            filter: action.tanks.filter,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    case actions.GET_AREAS:
    {
        return {
            ...state,
            areas: action.areas,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    case actions.GET_CURRENT_TANK:
    {
        return {
            ...state,
            currentTank: action.tank,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    case actions.ADD_TANK:
    {
        return {
            ...state,
            areas: state.areas.map((area, index) => {
                if (area.id !== action.tank.tankId) {
                    return area;
                }

                return { ...area, tanks: [...area.tanks, action.tank] };
            }),
            forceReload: true
        };
    }
    case actions.ADD_AREA:
    {
        return {
            ...state,
            areas: [...state.areas, action.area]
        };
            }
    case actions.EDIT_AREA:
    {
        return {
            ...state,
            areas: state.areas.map((item, index) => {
                if (item.areaId !== action.area.areaId) {
                    // This isn't the item we care about - keep it as-is
                    return item;
                }

                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.item
                };
            }),
            forceReload: true
        }
    }
    case actions.EDIT_TANK:
    {
        return {
            ...state,
            currentTank: Object.assign({}, emptyTank),
            areas: state.areas.map((area, index) => {
                if (action.tank.areaId !== area.areaId) {
                    return area;
                }

                return {
                    ...area,
                    tanks: area.tanks.map((tank) => {
                        if (tank.tankId !== action.tank.tankId) {
                            return tank;
                        }

                        return {
                            ...tank,
                            ...action.tank
                        }
                    })
                }
            }),
            forceReload: true
        };
    }
    case actions.GET_TANKS_OPERATIONS:
    {
        return {
            ...state,
            operations: action.tankOperations.items,
            operationsFilter: action.tankOperations.filter,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    case actions.GET_TANKS_STATE_OPERATIONS:
    {
        return {
            ...state,
            tanksStateOperations: action.tanksStateOperations.items,
            tanksStateOperationsFilter: action.tanksStateOperations.filter,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    default:
        return state;
    }
};